<div class="responsive-wrapper {{theme}}-theme" [class.in-modal]="inModal" [class.embed]="embed"
	[class.draft]="mediaclip?.status === 'draft'">
	<div class="wrapper" [class.no-player]="!project && !configuration.showVideo" [class.channel]="channel">
		<div class="config-fields" [hidden]="!embed">
			<h3 class="mobile">{{'EMBED' | translate}}</h3>
			<span
				*ngIf="(mediaclip && mediaclip.status === 'draft') || (playlist && playlist.status === 'draft') && !project"
				class="warning message ng-binding">
				<i class="fa fa-warning"></i>&nbsp;{{ 'HELP.PREVIEW_PAGE_WILL_NOT_WORK_WITH_DRAFT' | translate :
				{mediatype: (type)} }}
			</span>

			<span *ngIf="haveProjectRelation && !project" class="warning message">
				<i class="fa fa-warning"></i>&nbsp;{{ 'HELP.MEDIACLIP_ALSO_IN_PROJECTS_EMBED_WARNING' | translate }}
				<span *ngFor="let rel of mediaclip?.relationLabel" class="relation-label">
					<a *ngIf="relations[rel] && relations[rel].id"
						[routerLink]="['/library/project/' + relations[rel].id + '/embed']">
						Project: {{ relations[rel].label }}
					</a>
				</span>
			</span>

			<!-- selectedEmbedType-->
			<bb-form-element *ngIf="theme !== 'light-v2'" [label]="'EMBED_TYPE' | translate"
				[helpMessage]="'HELP.EMBED_TYPE' | translate"
				[helpMessageLink]="'https://support.bluebillywig.com/content-management/embedding-a-media-clip/'">
				<bb-select [(ngModel)]="selectedEmbedType" (ngModelChange)="embedCodeTypeChanged()"
					[options]="embedTypeOptions"></bb-select>
			</bb-form-element>

			<mat-form-field *ngIf="theme === 'light-v2'" appearance="fill" class="full-width">
				<mat-label>{{"EMBED_TYPE" | translate}}</mat-label>
				<mat-select [(ngModel)]="selectedEmbedType" (ngModelChange)="embedCodeTypeChanged()"
					[ngModelOptions]="{standalone: true}">
					<mat-option *ngFor="let option of embedTypeOptions" [value]="option.value">
						{{ option.label }}
					</mat-option>
				</mat-select>
			</mat-form-field>

			<!-- previewPlayoutCode -->
			<bb-form-element [label]="'PLAYOUT' | translate" *ngIf="!channel">
				<bb-entity-selector [entityType]="'playout'" [(ngModel)]="previewPlayoutCode" [disableClear]="true"
					[filterSet]="[{
						filters: [{
							type: 'playout',
							field: 'status',
							operator: 'isNot',
							value: 'inactive'
						}]
					}]" name="previewPlayoutCode" (optionSelected)="onPlayoutSelected(previewPlayoutCode)"></bb-entity-selector>
			</bb-form-element>

			<!-- context -->
			<ng-container *ngIf="contextOptions?.length">
				<bb-form-element [hasPublicationFieldOrPermission]="'projectContext'" [label]="'CONTEXT' | translate">
					<bb-select [(ngModel)]="context" (ngModelChange)="onContextChanged()" [options]="contextOptions"
						[placeholder]="'Select a context'"></bb-select>
				</bb-form-element>
			</ng-container>

			<hr *ngIf="theme !== 'light-v2'" />

			<!-- ctype/cid (channel) -->
			<ng-container *ngIf="channel">
				<bb-collapsible [title]="'ADVANCED' | translate" togglePosition="before" theme="blue">
					<p><i>{{ 'HELP.CHANNEL_CONTENT_EMBED' | translate }}</i></p>
					<mat-form-field appearance="fill" class="full-width">
						<mat-label>{{"CONTENT_TYPE" | translate}}</mat-label>
						<mat-select [(ngModel)]="ctype" (ngModelChange)="cid = null; channelCidChanged()"
							[name]="'ctype'">
							<mat-option>{{ 'NONE' | translate }}</mat-option>
							<mat-option *ngFor="let contentType of contentTypes" [value]="contentType.value">
								{{ contentType.label | translate }}
							</mat-option>
						</mat-select>
					</mat-form-field>
					<ng-container *ngFor="let type of contentTypes">
						<ng-container *ngIf="ctype === type.value">
							<mat-form-field appearance="fill" class="full-width pointer">
								<mat-label>{{ 'SELECT_'+type.label | translate }}</mat-label>
								<bb-entity-selector theme="light-v2" [inMatFormField]="true" [disableClear]="true"
									[hideThumbnail]="true" [hideIcons]="true" [entityType]="type.value"
									[(ngModel)]="cid" (ngModelChange)="channelCidChanged()" [name]="'cid'"
									placeholder="" [filterSet]="[{
									filters: [{
										type: type.value,
										field: 'status',
										operator: 'isNot',
										value: 'draft'
									}]
								}]"></bb-entity-selector>
							</mat-form-field>
						</ng-container>
					</ng-container>
				</bb-collapsible>
			</ng-container>

			<!-- embedCode -->
			<ng-container *ngIf="selectedEmbedType !== 'scorm'">
				<div *ngIf="theme !== 'light-v2'" class="textarea-container">
					<textarea readonly (click)="textareaClicked($event)" class="embedcode">{{ embedCode }}</textarea>
					<span class="button copy-embed" [hidden]="!embedCode" (click)="copyEmbedCode()"><i
							class="fa fa-copy"></i>{{ 'COPY' | translate }}</span>
				</div>

				<div *ngIf="theme === 'light-v2'">
					<mat-form-field appearance="fill" class="full-width">
						<textarea matInput readonly noresize (click)="textareaClicked($event)"
							style="resize:none;">{{embedCode}}</textarea>
					</mat-form-field>
					<div class="textarea-copy-container">
						<i *ngIf="!projectViewpageUrl">
							{{ "SAVE_CHANNEL_FIRST_FOR_URL" | translate }}
						</i>
						<a *ngIf="projectViewpageUrl" target="_blank" [href]="projectViewpageUrl">
							{{ 'OPEN_PREVIEW' | translate }}&nbsp;
							<i class="fa fa-external-link"></i>
						</a>
						<bb-button icon="copy" theme="light-v2" [hidden]="!embedCode" (click)="copyEmbedCode()">
							{{'COPY' | translate }}
						</bb-button>
					</div>
				</div>

				<div class="page-links" *ngIf="theme !== 'light-v2'">
					<a *ngIf="viewpageUrl" target="_blank" [href]="viewpageUrl">
						{{ 'OPEN_IN_VIEWPAGE' | translate }}
						<i class="fa fa-external-link"></i>
					</a>

					<a *ngIf="projectViewpageUrl" target="_blank" [href]="projectViewpageUrl">
						{{ 'OPEN_PREVIEW' | translate }}
						<i class="fa fa-external-link"></i>
					</a>
				</div>
			</ng-container>
			<ng-container *ngIf="selectedEmbedType === 'scorm'">
				<bb-button icon="download" class="download-button">
					<a href="{{ embedCode }}">
						{{ 'DOWNLOAD_SCORM_PACKAGE' | translate }}
					</a>
				</bb-button>
			</ng-container>
			<ng-content select=".embargo"></ng-content>
		</div>
		<div class="player" *ngIf="isActive">
			<bb-player
				*ngIf="configuration.showVideo && (playlist || (mediaclip && ( mediaclip.mediatype === 'video' || mediaclip.mediatype === 'audio')))"
				[mediaclip]="mediaclip" [assetId]="assetId" [playlist]="playlist" [autoplay]="configuration.autoPlay"
				[playout]="previewPlayout"
				[allowPlayerRefresh]="true"
				[playoutOverrides]="{width: '100%', responsiveSizing: 'true', allowImageSequence:'false', fullScreen:'Hide'}">
			</bb-player>

			<div class="mediaclip-thumbnail-image" *ngIf="mediaclip && mediaclip.mediatype === 'image'"><span
					[innerHTML]="mediaclip | thumbnail:1200:default | async"></span></div>

			<div *ngIf="project">
				<span *ngIf="!project.mainMediaClipId" class="message">
					<i class="fa fa-warning"></i>&nbsp;{{ 'HELP.PROJECT_NO_START_CLIP' | translate }}<a
						[href]="'#/library/project/' + project.id + '/flowchart'">&nbsp;Flowchart Tab</a>.
				</span>
			</div>

			<ng-content select=".custom-warning"></ng-content>

			<button class="button embed-toggle" (click)="embed = !embed; embedToggled();" [hidden]="embed"
				*ngIf="playlist || (mediaclip && mediaclip.usetype !== 'commercial' && !configuration.standAlone) && showEmbedTag"><i
					class="fa fa-code"></i> {{ 'EMBED' | translate }}</button>
		</div>
	</div>
</div>
